import React from 'react';

const C = { navy: '#0D1B2A', blue: '#1A4C7C', green: '#1D9E75', amber: '#E8A020', red: '#E24B4A', slate: '#5C6B7A' };
const MIN_REASON = 12;
const money = (v) => (v || v === 0 ? `$${Number(v).toLocaleString('en-AU', { maximumFractionDigits: 0 })}` : '—');

export default function ReassignRow({ claim: c, handlers, decision: d, onChange }) {
  const reasonOk = (d.reason || '').trim().length >= MIN_REASON;
  const tone = d.action === 'close' ? C.red : d.action === 'reassign' ? C.blue : d.action === 'keep' ? C.green : 'transparent';
  return (
    <tr className="border-t align-top" style={{ borderColor: 'rgba(136,150,168,0.15)', boxShadow: d.action ? `inset 3px 0 0 ${tone}` : 'none' }} data-testid={`reassign-row-${c.claim_id}`}>
      <td className="px-3 py-2 font-mono whitespace-nowrap" style={{ color: C.blue }}>{c.claim_reference || c.claim_number}<div className="text-[10px]" style={{ color: C.slate }}>{c.days_open}d open · {c.chases} chase(s)</div></td>
      <td className="py-2" style={{ color: C.navy }}><div className="truncate max-w-[200px]">{c.business_name}</div><div className="text-[10px] capitalize" style={{ color: C.slate }}>{(c.status || '').replace(/_/g, ' ')} · {c.claim_type || '—'}</div></td>
      <td className="py-2" style={{ color: C.slate }}>{c.handler_name || '—'}</td>
      <td className="py-2 text-right font-semibold" style={{ color: c.idle_days >= 90 ? C.red : C.amber }} data-testid={`reassign-idle-${c.claim_id}`}>{c.idle_days}d</td>
      <td className="py-2 text-right" style={{ color: C.navy }}>{money(c.reserve_amount)}</td>
      <td className="py-2 pl-3 max-w-[260px]" style={{ color: C.slate }}>{c.last_human_note ? <span title={c.last_human_note.text}>{c.last_human_note.at?.slice(0, 10)} · {c.last_human_note.by}: {c.last_human_note.text}</span> : <em>none since FNOL</em>}</td>
      <td className="py-2 pl-3">
        <select value={d.action || ''} onChange={e => onChange({ action: e.target.value || undefined })} className="text-[11px] border rounded-sm px-1.5 py-1 bg-white w-full" data-testid={`reassign-action-${c.claim_id}`}>
          <option value="">— decide —</option>
          <option value="reassign">Reassign</option>
          <option value="close">Close</option>
          <option value="keep">Keep (I'll work it)</option>
        </select>
        {!d.action && <div className="text-[9px] mt-0.5" style={{ color: C.slate }}>ARIA suggests: {c.suggest}</div>}
      </td>
      <td className="py-2">
        {d.action === 'reassign' && (
          <select value={d.handler_id || ''} onChange={e => onChange({ handler_id: e.target.value || undefined })} className="text-[11px] border rounded-sm px-1.5 py-1 bg-white w-full" data-testid={`reassign-handler-${c.claim_id}`}>
            <option value="">handler…</option>
            {handlers.filter(h => h.id !== c.handler_id).map(h => <option key={h.id} value={h.id}>{h.name} ({h.open_files} open)</option>)}
          </select>
        )}
      </td>
      <td className="py-2 pr-3">
        {d.action && (
          <>
            <input value={d.reason || ''} onChange={e => onChange({ reason: e.target.value })} placeholder={`why — min ${MIN_REASON} chars`} className="text-[11px] border rounded-sm px-1.5 py-1 bg-white w-full" style={{ borderColor: d.reason && !reasonOk ? C.amber : undefined }} data-testid={`reassign-reason-${c.claim_id}`} />
            {d.reason && !reasonOk && <div className="text-[9px]" style={{ color: C.amber }}>{MIN_REASON - d.reason.trim().length} more character(s)</div>}
          </>
        )}
      </td>
    </tr>
  );
}
